import { InvalidArgumentError } from "../../../../../../../Common/Errors";
import { sizeToken } from "../ThemeBuilder/ICandyTheme";

export enum LengthUnit {
    px = "px",
}

export class Length {
    private readonly value: number;
    private readonly unit: LengthUnit;

    public constructor(value: number, unit: LengthUnit) {
        this.unit = unit;
        this.value = value;
    }

    public toString(): string {
        return `${this.value}${this.unit}`;
    }

    public css(): string {
        return `${this.value}${this.unit}`;
    }

    public getNumber(): number {
        return this.value;
    }

    public getValue(unit: LengthUnit): number {
        if (unit === this.unit) {
            return this.value;
        } else {
            throw new Error(`Cannot convert ${this.unit} to ${unit}`);
        }
    }

    public add(value: Length): Length {
        if (value.unit !== this.unit) {
            throw new InvalidArgumentError("value", "add available for same unit lengths only");
        }
        return new Length(this.value + value.value, this.unit);
    }

    public map(update: (value: number) => number): Length {
        return new Length(update(this.value), this.unit);
    }

    public static tokens(tokens: number): Length {
        return new Length(sizeToken(tokens), LengthUnit.px);
    }

    public static token(): Length {
        return Length.tokens(1);
    }

    public static halfToken(): Length {
        return Length.tokens(0.5);
    }

    public static px(value: number): Length {
        return new Length(value, LengthUnit.px);
    }
}
